import RentalRate from './RentalRate';

export default RentalRate;
